export default function blockLogotypes() {


    if (document.querySelectorAll('.logotypes-slider:not(.logotypes-slider--disabled)').length === 0) {return;}

    let swiperInstances = [];

    function initSwiper() {
        if (window.innerWidth < 768 && swiperInstances.length === 0) {
            import('swiper/bundle').then(({ default: Swiper }) => {
                document.querySelectorAll('.logotypes-slider:not(.logotypes-slider--disabled)').forEach(function(slider) {
                    const swiper = new Swiper(slider, {
                        speed: 1000,
                        loop: true,
                        spaceBetween: 2,
                        autoplay: {
                            delay: 4000,
                            disableOnInteraction: true,
                        },
                        navigation: {
                            nextEl: slider.querySelector('.logotypes-slider__arrow--next'),
                            prevEl: slider.querySelector('.logotypes-slider__arrow--prev'),
                        },
                        breakpoints: {
                            0: {
                                slidesPerView: 2,
                            }
                        },
                    });
                    swiperInstances.push(swiper);
                });
            });
        } else if (window.innerWidth >= 768 && swiperInstances.length > 0) {
            swiperInstances.forEach(swiper => swiper.destroy(true, true));
            swiperInstances = [];
        }
    }

    initSwiper();

    window.addEventListener('resize', () => {
        initSwiper();
    });


}
